import React from "react";
import Text from "../../../../../../../components/Text";

interface LinkButtonProps {
  onClick: () => void;
  children: React.ReactNode;
  underLineOnHover?: boolean;
}

/**
 *
 * @param onClick - The function to call when the button is clicked
 * @param children - The text to display in the button
 * @param underLineOnHover - Whether to underline the text on hover
 *
 * @author [Rajkumar Rathod]
 */
const LinkButton = ({
  onClick,
  children,
  underLineOnHover = false,
}: LinkButtonProps) => {
  return (
    <Text
      c="primary.main"
      fontWeight={450}
      sx={{
        cursor: "pointer",
        textDecoration: underLineOnHover ? "none" : "underline",
        ":hover": {
          textDecoration: "underline",
        },
      }}
      onClick={onClick}
    >
      {children}
    </Text>
  );
};

export default LinkButton;
